import { ApiCore } from '@/services/api/utils/core.js'

const url = 'user/user-data-element'

const api = new ApiCore({
	index: true,
	create: true,
	url: url
})

export default api
